

//['SingleTarget', 'Cone', 'Location', 'Map', 'Chain', 'AoE']
const SINGLE_TARGET = 'SingleTarget';
const CONE = 'Cone';
const SPHERE = 'AoE';
export const ATTACK_TYPES = [
    {name: 'Single Target', value: SINGLE_TARGET},
    {name: 'Cone', value: CONE},
    {name: 'Sphere', value: SPHERE}
    //{name: 'Chain', value: 'Chain'}
];

export function arcanify(duration) {
    return Math.round((Math.ceil(duration / 0.132) + 1) * 0.132 * 1000) / 1000;
}

export function area_factor(power_type, radius=0, arc=360) {
    if(power_type == SINGLE_TARGET)
        return 1;
    if(power_type == CONE)
        return 1 + 0.15 * radius - 0.011 * radius * (360 - arc) / 30;
    if(power_type == SPHERE)
        return 1 + 0.15 * radius;
    console.log('Unexpected power type');
    return 0;
}

export function proc_probability(proc, power, recharge_boost) {
    const af = area_factor(power.attack_type, power.radius, power.arc);
    const am = 0.25 + 0.75 * af;
    const mrt = power.recharge / (1 + recharge_boost / 100);

    const prob = Math.min(0.9, proc.ppm * (mrt + power.arcanatime) / (60 * am));
    return prob;
}

/* avg_tick_total calculates the effective number of ticks of a power.
   For effects that don't cancel-on-miss, this is just the tick count.
   For those that do, if each tick has a less than 100% chance, then each
   subsequent tick will have lower odds of occurring.
*/
function avg_tick_total(effect) {
    if(effect.tick_chance_percent === undefined
         || effect.flags === undefined
         || effect.flags.find(val => val == 'CancelOnMiss') === undefined )
        return effect.ticks;
    const chance = effect.tick_chance_percent / 100; // Chance for a single tick
    // Build an array of chance values for each tick
    const chances = Array(effect.ticks).fill(chance).map((val, ndx) => Math.pow(val, ndx + 1));
    // Sum them for total chance value
    const avg = chances.reduce((a, b) => a + b, 0);
    return avg;
}

function minmax(val, min, max) {
    if(val >= min && val <= max)
        return val;
    if(val > max)
        return max;
    return min;
}

function eval_magexpr(expr, val) {
    expr = expr
        .replace(/@StdResult/g, val)
        .replace(/source>cur.kToHit/g, '0.97')
        .replace(/source.ownPowerNum\?\(Temporary_Powers.Temporary_Powers.Savage_Melee_Blood_Frenzy_Stalker\)/g, '5');

    let retval = eval(expr);
    if(retval === undefined)
        return val;
    console.log(val, ' -> ', retval);
    return retval;
}

function effect_group_damage(eg) {
    if(eg.pve_or_pvp && eg.pve_or_pvp != 'PVE')
        return 0;  // Ignore PVP values

    if (eg.tags !== undefined)
        return 0;  // Ignore Fiery Embrace, Criticals, etc.

    if (eg.requires !== undefined) {
        const req = eg.requires[0];
        if(req.indexOf('kMeter') >= 0)
            return 0;  // Ignore Stalker criticals
        if(req.indexOf('Savage_Melee_Blood_Frenzy') >= 0
           && req.endsWith('< 5)'))
            return 0;  // Only handle max Blood Frenzy case
    }

    if (eg.chance_percent !== undefined && eg.chance_percent != 100)
        return 0;  // Hopefully it's safe to ignore effects with a "chance of"
    
    const scaled_reducer = (acc, val) => {
        return acc + val.damage || 0;
    }
    const effect_reducer = (acc, val) => {
        if(val.scaled === undefined)  // No damage to add
            return acc;
        if(val.target_type !== undefined && val.target_type == 'Self')
            return acc;  // Don't include self-damage (Energy Transfer)

        // Sum all damage attributes in this "scaled" array.
        let dmg = val.scaled.reduce(scaled_reducer, 0);
        if(val.magnitude_expression !== undefined) {
            dmg = eval_magexpr(val.magnitude_expression, dmg);
        }
        if(val.ticks !== undefined)
            dmg *= avg_tick_total(val);
        return acc + dmg;
    }
    // Sum damage of all effects in the group
    let damage = eg.effects.reduce(effect_reducer, 0);
    return Math.round(damage * 1000) / 1000; // Round to 3 places
}

export function power_damage(power) {
    if(power.effect_groups === undefined) {
        console.log('Unable to calculate damage for ' + power.name || 'unknown');
        return 0;
    }

    // Sum damage of all effect groups that are not PVP
    return power.effect_groups.reduce((acc, val) => acc + effect_group_damage(val), 0);
}



let data = {};
const DATA_URL = 'https://coh.tips/powers/v2/';

function get_data(url, callback) {
    return fetch(url)
        .then(response => response.json());
}

function get_data2(url, callback) {
    fetch(url)
        .then(response => response.json())
        .then(data => callback(data));
}

// find_by_name is a method that can be assigned to any array containing appropriate objects
function find_by_name(name) {
    return this.find((val) => val.name == name);
}

function category_name(cat) {
    return (cat.archetype && cat.archetype.display_name) || cat.display_name;
}

// Comparison function used for sorting a list of power categories
function category_compare(a, b) {
    return category_name(a) > category_name(b);
}

const get_root = (() => {
    let promise;
    return () => {
        if(promise === undefined) {
            promise = fetch(DATA_URL)
                .then(response => response.json());
            promise.then(data => {
                data.power_categories.for_archetype = function(archetype) {
                    return this.filter((val) => val.archetype.name == archetype);
                }
                data.power_categories.by_name = find_by_name;
                data.power_categories.sort(category_compare);
                return data;
            });
        }
        return promise;
    };
})();


/* get_root gets the root document in a way that will hopefully allow it to
    be called multiple times while only fetching the external resource once. */
const get_root2 = (() => {
    let loading = false;
    let callbacks = [];
    return (callback) => {
        callbacks.push(callback);
        if(loading)
            return;
        loading = true;
        get_data(DATA_URL, (new_data) => {
            data = new_data;
            loading = false;
            data.power_categories.for_archetype = function(archetype) {
                return this.filter((val) => val.archetype.name == archetype);
            }
            data.power_categories.by_name = find_by_name;
            data.power_categories.sort(category_compare);
            callbacks.forEach((cb) => {
                cb(data);
            });
            callbacks = [];
        });
    }
})();

export async function get_archetypes() {
    let data = await get_root();
    if(data.arch_data === undefined) {
        let response = await fetch(data.archetypes);
        let new_data = await response.json();
        data.arch_data = new_data;
    }
    return data.arch_data.archetypes;
}

export const get_archetypes2 = (callback) => {
    const get_arch_data = () => {
        get_data(data.archetypes, (new_data) => {
            data.arch_data = new_data;
            data.arch_data.by_name = find_by_name;
            callback(data.arch_data.archetypes);
        });
    }
    if(data.archetypes === undefined) {
        get_root((_) => {
            get_arch_data();
        })
        return;
    }
    if(data.arch_data === undefined) {
        get_arch_data();
        return;
    }
    callback(data.arch_data.archetypes);
}

export async function get_power_categories() {
    let data = await get_root();
    return data.power_categories;
}

export const get_power_categories2 = (callback) => {
    if(data.categories === undefined) {
        get_root((_) => {
            callback(data.power_categories);
        })
        return;
    }
    callback(data.power_categories);
}

function get_category_data(category, callback) {
    let cat = data.power_categories.by_name(category);
    get_data(cat.url, (new_data) => {
        cat.power_sets = new_data.power_sets;
        cat.power_sets.by_name = find_by_name;
        callback(cat.power_sets);
    });
}

export async function get_power_sets(category) {
    if(!category)
    {
        return [];
    }
    let data = await get_root();
    let cat = data.power_categories.by_name(category);
    if(cat.power_sets === undefined) {
        let new_data = await get_data(cat.url);
        cat.power_sets = new_data.power_sets;
        cat.power_sets.by_name = find_by_name;
    }
    return cat.power_sets;
}

export const get_power_sets2 = (category, callback) => {
    if(!category)
    {
        callback([]);
        return;
    }
    if(data.categories === undefined) {
        get_root((_) => {
            get_category_data(category, callback);
        })
        return;
    }
    let cat = data.power_categories.by_name(category);
    if(cat.power_sets === undefined) {
        get_category_data(category, callback);
        return;
    }
    callback(cat.power_sets);
}

/* generate_display_name will create a display name from a fully qualified name.
   This is necessary for redirected powers because each version has the same
   display name by default.  This gives them each a unique display name.
*/
function generate_display_name(power) {
    power.display_name = power.name.substring(power.name.lastIndexOf('.') + 1);
}

/* fixup_powers will expand any power redirects, such as snipes or AS.
*/
async function fixup_powers(powers) {
    for(let i = 0; i < powers.length; i++) {
        let power = powers[i];
        if(power.redirects !== undefined) {
            let new_data = await get_data(power.redirects[0].url);
            new_data.powers.forEach(generate_display_name);
            power.hidden = true;  // Don't use the original anymore
            powers = [...powers.slice(0, i), ...new_data.powers, ...powers.slice(i)];
            i += new_data.powers.length;
        }
    }
    return powers;
}

export async function get_powers(category, powerset) {
    if(!category || !powerset)
    {
        return [];
    }
    let sets = await get_power_sets(category);
    let set = sets.by_name(powerset);
    if(set.powers === undefined)
    {
        let new_data = await get_data(set.url);
        set.powers = await fixup_powers(new_data.powers);
        set.powers.by_name = find_by_name;
    }
    return set.powers;
}

export const get_powers2 = (category, powerset, callback) => {
    if(!category || !powerset)
    {
        callback([]);
        return;
    }
    const get_powerset_data = () => {
        let cat = data.power_categories.by_name(category);
        let set = cat.power_sets.by_name(powerset);
        get_data(set.url, (new_data) => {
            set.powers = new_data.powers;
            set.powers.by_name = find_by_name;
            callback(set.powers);
        });
    }
    if(data.categories === undefined) {
        get_root((_) => {
            get_category_data(category, get_powerset_data);
        })
        return;
    }
    let cat = data.power_categories.by_name(category);
    if(cat === undefined)
    {
        get_category_data(category, get_powerset_data);
        return;
    }
    let set = cat.power_sets.by_name(powerset);
    if(set.powers === undefined)
    {
        get_powerset_data();
        return;
    }
    callback(set.powers);
}